
    <div class="invitation-card">
      <overlay-loading *ngIf="loading"></overlay-loading>

      <div class="title">Copie o link e compartilhe</div>

      <div class="share-content">
        <span>{{originalLink}}</span>

        <button
          [class.active]="copied"
          [copy-clipboard]="inviteLink"
          (copied)="onCopy()"
        >
            {{ copied ? 'copiado' : 'copiar' }}
        </button>
      </div>

      <button class="share-btn" (click)="share()">Whatsapp</button>
    </div>
  